import { AggregatorModel } from "./Aggregator.model";
import { ContactsModel } from "./Contacts.model";
import { LegalRepresentativeModel } from "./LegalRepresentative.model";
import { PartnersModel } from "./Partners.model";
import { RequestIdentificationModel } from "./RequestIdentification.model";
import { RequestLocationModel } from "./RequestLocation.model";
import { SignatureUsersModel } from "./SignatureUsers.model";
import { RequestStatusModel } from "./RequestStatus.model";
import { environment } from "src/environments/environment";
import { AgencyTypeModel } from "./AgencyType.model";
import { ConnectionTypeModel } from "./ConnectionType.model";
import { ContractTermsAgencyModel } from "./ContractTermsAgency.model";
import { ParametersModel } from "./Parameter.model";
import { Flows } from "./Enums/Flow.enums";
import { FinalBeneficiaries } from "./FInalBeneficiaries.model";
import { FinalBeneficiariesAnswers } from "./FinalBeneficiariesAnswers.model";
export class RequestModel {
  public AggregatorId: number;
  public AgencyType: number;
  public AggregatorIdGeo: string;
  public IdFlow: number;
  public AggregatorName: string;
  public AggregatorNameGeo: string;
  public ConnectionType: number;
  public CreatedBy: string;
  public CreatedDate: Date;
  public Email: string;
  public AggregatorEmail1: string;
  public AggregatorEmail2: string;
  public AggregatorEmail3: string;
  public Iata: string;
  public CodeIata: string;
  public Id: number;
  public IdBillingPeriod: number;
  public DigitoVerificacion: number;
  public CityId: number;
  public CityName: string;
  public CountryName: string;
  public Language: string;
  public ModifiedBy: string;
  public ModifiedDate: Date;
  public PrincipalOffice: string;
  public RequestCode: string;
  public RequestDate: Date;
  public RequestStatus: number;
  public RequestType: number;
  public Contacts: ContactsModel[];
  public RequestIdentification: RequestIdentificationModel[];
  public LegalRepresentative: LegalRepresentativeModel[];
  public RequestLocation: RequestLocationModel[]
  public Aggregator: AggregatorModel;
  public Partners: PartnersModel[];
  public FinalBeneficiaries: FinalBeneficiaries[];
  public FinalBeneficiariesAnswers: FinalBeneficiariesAnswers[];
  public SignatureUsers: SignatureUsersModel[];
  public RequestStatusNavigation: RequestStatusModel;
  public AgencyRequiredDocument: any;
  public AgencyTypeNavigation: AgencyTypeModel;
  public ConnectionTypeNavigation: ConnectionTypeModel
  public EnabledTicketingAuthority : boolean
  public AP_AR : boolean
  public IsIATABlocked : boolean
  public ContractTermsAgency: ContractTermsAgencyModel[];
  public Parameter: ParametersModel;
  public AllowUpdateStatus:boolean;
  public AllowUpdateStatusFrom :Date;
  public IsUpdateCrm : boolean;
  public IsUpdateCrmLocation : boolean;
  public AllowSignDocuments: boolean;
  public IsNewIata : boolean;
  public IataFather: string;
  public AllowUploadPolicy: boolean;
  public AllowUploadExtraWarranty: boolean;
  public ExtraWarrantyAttempts: number;
  public AllowApprovalLegalDocument: boolean;
  public UpdateCrmDone: number;
  public ApproveTermsLegal: string;
  public ApproveTermsBool: string;
  public ApproveTermsLegalComent: string;
  public IsSabreNdc: boolean;
  public IsAmadeusNdc: boolean;
  public IsTravelPortNdc : boolean;

  completeOverview(): boolean {
    const syncFlows = new Set([Flows.Flujo3_1,Flows.Flujo3_2])
    if(syncFlows.has(this.IdFlow))
    return this.Id > 0 && this.Email != null && this.AggregatorIdGeo != null
    else
    return this.Id > 0 && this.Email != null
  }
  completeIdentification(): boolean {
    return this.RequestIdentification != null
      && this.RequestIdentification.length > 0
      && this.RequestIdentification[0].BusinessName != null
      && this.RequestIdentification[0].IdGlobalName != null
      && this.RequestIdentification[0].Phone != null
      && this.RequestIdentification[0].SaleTypeName != null
      && this.RequestIdentification[0].Address != null
  }
  completeLocation(): boolean {
    return this.RequestLocation != null
      && this.RequestLocation.length > 0
      && this.RequestLocation[0].IdLanguage != null
  }
  completeLegal(): boolean {
    const syncFlows = new Set([Flows.Flujo3_1,Flows.Flujo3_2,Flows.Flujo4_1,Flows.Flujo4_2,Flows.Flujo6_1,Flows.Flujo6_2])
    if(syncFlows.has(this.IdFlow)){
      if (this.LegalRepresentative[0] != null && this.LegalRepresentative[0].IdNationality == environment.request.countryUnitedStates ||
      this.LegalRepresentative[0].IdNationality == environment.request.countryUnitedKingdom ||
      this.LegalRepresentative[0].IdNationality == environment.request.countryIsrael ||
      this.LegalRepresentative[0].IdNationality == environment.request.countryGermany){
        return this.LegalRepresentative != null
        && this.LegalRepresentative.length > 0
        && this.LegalRepresentative[0].IdNationality != null
        && this.LegalRepresentative[0].BirthDate != null
      }
      else
        return this.LegalRepresentative != null
        && this.LegalRepresentative.length > 0
        && this.LegalRepresentative[0].IdNationality != null
      
    }
    else
    return this.LegalRepresentative != null
      && this.LegalRepresentative.length > 0
      && this.LegalRepresentative[0].IdNationality != null
  }
  completeAdminPortal(): boolean {
    return this.Contacts != null
      && this.Contacts.length > 0
  }
  completePartners(): boolean {
    let r: number = 0;
    if (this.Partners != null && this.Partners.length > 0) {
      this.Partners.forEach(x => {
        r = r + x.Percentage;
      })
    }
    if(this.FinalBeneficiariesAnswers != undefined && this.FinalBeneficiariesAnswers.length >0){
      if(this.FinalBeneficiariesAnswers[0].PartnersAreFinalBeneficiariesQuestion)
        return r >= 60;
      else if(this.FinalBeneficiariesAnswers[0].ShareFinalBeneficiariesInformation)
        return r >= 60 && this.FinalBeneficiaries.length > 0;
      else
      return r >= 60 && this.FinalBeneficiariesAnswers[0].FinalBeneficiariesJustification != undefined
    }
    else{
      return false;
    }
  }
  completeSignatures(): boolean {
    let r: boolean
    if (this.ConnectionType == environment.request.iataConnectionType || this.ConnectionType == environment.request.noIataConnectionType || this.ConnectionType == environment.request.iataNDCConnectionType) {
      if(this.IsUpdateCrm != true){
        r = this.SignatureUsers != null
        && this.SignatureUsers.length > 0
        && this.SignatureUsers.some(x => x.Role == environment.request.supervisorRoleARD)
      }
      else{
        r = true
      }

    }
    else
      r = true;
    return r
  }
   completeAll(): boolean {

     return this.completeOverview()
       && this.completeIdentification()
       && this.completeLocation()
       && this.completeLegal()
       && this.completeAdminPortal()
       && this.completePartners()
       && this.completeSignatures()

   }
}
